import "es6-promise/auto";
import axios from "axios";
import { getAccessToken, getIdToken, getJwtToken } from "./AuthService";
import { getFolderId, getMainFolderId } from "./localStorage";
import { config } from "../constants/config";
import { sanitize } from "../components/utils/utils";

const apiUrl = config.API_URL;

// Agenda
export function agendasForProgramId(programid, datum) {
  return axios({
    method: "post",
    url:
      apiUrl +
      "/agendas/agendasforprogramid?programid=" +
      programid +
      "&datum=" +
      datum,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function agenda(agendaId) {
  return axios({
    method: "get",
    url: apiUrl + "/agendas/agenda/" + agendaId,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function addagenda(data) {
  return axios({
    method: "post",
    url: apiUrl + "/agendas/addagenda",
    data: data,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function updateagenda(data) {
  return axios({
    method: "post",
    url: apiUrl + "/agendas/updateagenda",
    data: data,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function agendaInUitzending(agendaId, uitzendingId) {
  return axios({
    method: "post",
    url: `${apiUrl}/agendas/agendainuitzending?agendaid=${agendaId}&uitzendingId=${uitzendingId}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function deleteAgendaItem(agendaId) {
  return axios({
    method: "delete",
    url: `${apiUrl}/agendas/deleteAgendaItem/${agendaId}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

// BGROUP
// Get Maingroups
export function getMaingroups() {
  return axios({
    method: "post",
    url: apiUrl + "/maingroups/maingroups",
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

// Get groups from maingroup
export function getGroupsFromMaingroup(maingroupid) {
  return axios({
    method: "post",
    url: apiUrl + "/maingroups/groups/" + maingroupid,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

// Get subgroups and items for groupid
export function getSubgroupsAndItem(groupid) {
  return axios({
    method: "post",
    url: apiUrl + "/groups/subgroupsanditems/" + groupid,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

// Add group to maingroup
export function addGroupToMaingroup(name) {
  var params = new URLSearchParams();
  params.append("Name", name);
  params.append("MainGroupID", getMainFolderId());

  return axios({
    method: "post",
    url: apiUrl + "/groups/addgroup",
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

// Add group
export function addGroup(name, parentGroupId) {
  var params = new URLSearchParams();
  params.append("Name", name);
  params.append("ParentGroupID", parentGroupId);

  return axios({
    method: "post",
    url: apiUrl + "/assetGroups/addgroup",
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

// BITEMS
// Get Item
export function getItem(id) {
  return axios({
    method: "post",
    url: apiUrl + "/items/item/" + id,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

// Add Item
export function addItem(name, metadata) {
  var params = new URLSearchParams();
  params.append("Name", name);
  params.append("GroupID", getFolderId());

  return axios({
    method: "post",
    url: apiUrl + "/items/additem",
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(data => {
      var params = new URLSearchParams();
      params.append("ItemID", data.data.ItemID);
      params.append("Key", "metadata");
      params.append("Value", metadata);

      return axios({
        method: "post",
        url: apiUrl + "/items/addkeyvalue",
        data: params,
        headers: {
          Authorization: getAccessToken()
        }
      })
        .then(res => res.data)
        .catch(error => error);
    })
    .catch(error => error);
}

// Update Item
export function updateItem(name, id) {
  var params = new URLSearchParams();
  params.append("Name", name);
  params.append("ItemID", id);
  params.append("GroupID", getFolderId());

  return axios({
    method: "post",
    url: apiUrl + "/items/updateitem",
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

// PERSON
// Get user KeyValues
export function getUserKeyValues(userID) {
  return axios({
    method: "post",
    url: apiUrl + "/Person/keyvalues/" + userID,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

// Add user KeyValues
export function addUserKeyValues(userID, key, value) {
  var params = new URLSearchParams();
  params.append("UserID", userID);
  params.append("Key", key);
  params.append("Value", value);

  return axios({
    method: "post",
    url: apiUrl + "/Person/keyvalues",
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

// Update user KeyValues
export function updateUserKeyValues(userID, key, value) {
  var params = new URLSearchParams();
  params.append("UserID", userID);
  params.append("Key", key);
  params.append("Value", value);

  return axios({
    method: "post",
    url: apiUrl + "/Person/updatekeyvalues",
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

// CHANNEL
export function getAllChannelsForPersonWithRole(personId, rolePrefix) {
  return axios({
    method: "get",
    url:
      apiUrl +
      "/Channels/GetAllChannelsForPersonWithRole/" +
      personId +
      "?rolePrefix=" +
      rolePrefix,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function GetAllChannels() {
  return axios({
    method: "get",
    url: apiUrl + "/Channel",
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function addChannel(channel) {
  return axios({
    method: "post",
    url: apiUrl + "/Channel",
    data: channel,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getChannel(id) {
  return axios({
    method: "get",
    url: `${apiUrl}/Channels/${id}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}
export function getChannelTypes() {
  return axios({
    method: "get",
    url: `${apiUrl}/Channels/GetAllChanneltypes`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

// BCM PROGRAM
export function GetAllPrograms() {
  return axios({
    method: "get",
    url: apiUrl + "/Program",
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getProgram(programId) {
  return axios({
    method: "get",
    url: apiUrl + "/Program/" + programId,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getProgramsForChannel(channelId) {
  var params = new URLSearchParams();
  params.append("channelID", channelId);

  return axios({
    method: "get",
    url: apiUrl + "/Program/ProgramsForChannel/" + channelId,
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function GetProgramsUserHasRightsForByChannel(
  channelId,
  personId,
  prefix = ""
) {
  return axios({
    method: "post",
    url: `${apiUrl}/Program/GetProgramsUserHasRightsForByChannelWithPrefix/${channelId}/${personId}?prefix=${prefix}`,
    data: prefix,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getProgramOfChannelUserHasAccessTo(
  channelId,
  programId,
  personId = parseInt(getIdToken(), 10)
) {
  return axios({
    method: "get",
    url: `${apiUrl}/Program/GetProgramOfChannel/${channelId}/${programId}/${personId}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getThumnailForProgram(programId) {
  var params = new URLSearchParams();
  params.append("programid", programId);

  return axios({
    method: "post",
    url: apiUrl + "/Program/bannerthumbnailimage/" + programId,
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function addThumnailToProgram(ProgramId, Base64Image, triton = false) {
  var params = new URLSearchParams();
  params.append("ProgramId", ProgramId);
  params.append("Base64Image", Base64Image);
  params.append("Triton", triton);

  return axios({
    method: "post",
    url: apiUrl + "/Program/AddThumbnailToProgram",
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function addThumnailToChannel(channelId, Base64Image, triton = false) {
  var params = new URLSearchParams();
  params.append("ChannelId", channelId);
  params.append("Base64Image", Base64Image);
  params.append("Triton", triton);

  return axios({
    method: "post",
    url: apiUrl + "/Channels/AddThumbnailToChannel",
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

// BCM PERSON
export function getPersonsForProgram(programId) {
  var params = new URLSearchParams();
  params.append("programid", programId);

  return axios({
    method: "get",
    url: apiUrl + "/Person/personsforprogramid/" + programId,
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function addPersonToProgram(personId, programId) {
  var params = new URLSearchParams();
  params.append("programid", programId);
  params.append("personId", personId);

  return axios({
    method: "post",
    url: apiUrl + `/Authorization/AddPersonToProgram/${personId}/${programId}`,
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function removePersonFromProgram(personId, programId) {
  var params = new URLSearchParams();
  params.append("programid", programId);
  params.append("personId", personId);

  return axios({
    method: "delete",
    url: apiUrl + `/Authorization/RemovePersonFromProgram/${personId}/${programId}`,
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

// BCM PERSON
export function getPersonsForProgramByChannelCompany(programId) {
  var params = new URLSearchParams();
  params.append("programid", programId);

  return axios({
    method: "get",
    url: apiUrl + "/Person/personsforprogramid/" + programId + "/by-channel-company",
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

// BCM ITEMS

export function getMetadataForBcm(bcmNr) {
  return axios({
    method: "get",
    url: `${apiUrl}/Uitzending/GetMetadataForBCMNr?bcmNr=${bcmNr}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getItemsForUitzending(uizendingId) {
  var params = new URLSearchParams();
  params.append("uitzendingid", uizendingId);

  return axios({
    method: "get",
    url: apiUrl + "/items/itemsforuitzendingid/" + uizendingId,
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function itemuitzending(ItemID) {
  return axios({
    method: "get",
    url: apiUrl + "/items/itemuitzending?itemuitzendingId=" + ItemID,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function newItemUitzending(uitzendingId, Titel, ItemTypeID, ReporterID) {
  var params = new URLSearchParams();
  params.append("UitzendingID", uitzendingId);
  params.append("Titel", Titel);
  params.append("ItemTypeID", ItemTypeID);
  params.append("ReporterID", ReporterID);

  return axios({
    method: "post",
    url: apiUrl + "/items/newitemuitzending",
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function updateItemUitzending(
  id,
  itemId,
  webtitel,
  webtekst,
  Geen_preroll,
  Bevat_aangekochte_beelden,
  FotoCategorie,
  webtekstHTML
) {
  var params = new URLSearchParams();
  params.append("ID", id);
  params.append("ItemID", itemId);
  params.append("WebTitel", webtitel);
  params.append("WebTekst", webtekst);
  params.append("Geen_preroll", Geen_preroll);
  params.append("Bevat_aangekochte_beelden", Bevat_aangekochte_beelden);
  params.append("FotoCategorie", FotoCategorie);
  params.append("WebTekst_html", webtekstHTML);

  return axios({
    method: "put",
    url: apiUrl + "/items/updateitemuitzending",
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function updateItemuitzendingTitel(Id, ItemID, titel) {
  var params = new URLSearchParams();
  params.append("ID", Id);
  params.append("ItemID", ItemID);
  params.append("Titel", titel);

  return axios({
    method: "put",
    url: apiUrl + "/items/updateitemuitzending",
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function updateorderitemsuitzending(UitzendingId, ItemsVolgorde) {
  var data = {
    UitzendingId: UitzendingId,
    ItemsVolgorde: ItemsVolgorde
  };

  return axios({
    method: "post",
    url: apiUrl + "/items/updateorderitemsuitzending",
    data: data,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function updateorderSubitems(
  ItemId,
  Subitemsvolgorde,
  modifiedByPersonId = parseInt(getIdToken(), 10)
) {
  var data = {
    ItemId: ItemId,
    Subitemsvolgorde: Subitemsvolgorde,
    ModifiedByPersonId: modifiedByPersonId
  };

  return axios({
    method: "put",
    url: apiUrl + "/items/updateordersubitems",
    data: data,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function formatsForProgramId(uitzendingid) {
  return axios({
    method: "get",
    url: apiUrl + "/items/formatsforprogramid/" + uitzendingid,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function applyFormat(formatid, uitzendingid) {
  return axios({
    method: "post",
    url:
      apiUrl +
      "/items/applyformat?formatid=" +
      formatid +
      "&uitzendingid=" +
      uitzendingid,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function geenPreroll(id, geenPreroll) {
  var params = new URLSearchParams();
  params.append("ID", id);
  params.append("Geen_preroll", geenPreroll);

  return axios({
    method: "post",
    url: apiUrl + "/items/updateitemuitzending",
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function updateitemuitzendingAfgewerktTekst(itemId, status) {
  return axios({
    method: "put",
    url:
      apiUrl +
      "/items/updateitemuitzendingAfgewerktTekst/" +
      itemId +
      "/" +
      status,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function updateitemuitzendingAfgewerktVideo(itemId, status) {
  return axios({
    method: "put",
    url:
      apiUrl +
      "/items/updateitemuitzendingAfgewerktVideo/" +
      itemId +
      "/" +
      status,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function updateitemuitzendingUitzendingTypeEnabled(ID, ItemID, status) {
  var params = new URLSearchParams();
  params.append("ID", ID);
  params.append("ItemID", ItemID);
  params.append("UitzendingTypeEnabled", status);

  return axios({
    method: "put",
    url: apiUrl + "/items/updateitemuitzending",
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function deleteitemuitzending(itemId, uitzendingId) {
  return axios({
    method: "delete",
    url: apiUrl + "/items/deleteitemuitzending/" + itemId + "/" + uitzendingId,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function addSubItem(itemId, typeId, Volgnr) {
  var params = new URLSearchParams();
  params.append("ItemID", itemId);
  params.append("TypeID", typeId);
  params.append("Volgnr", Volgnr);

  return axios({
    method: "post",
    url: apiUrl + "/items/addsubitem",
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function deleteSubItem(itemId) {
  return axios({
    method: "delete",
    url: apiUrl + "/items/deletesubitem?subitemID=" + itemId,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function updateSubitemText(ID, ItemID, text) {
  var params = new URLSearchParams();
  params.append("ID", ID);
  params.append("ItemID", ItemID);
  params.append("Tekst", text);
  params.append("ModifiedByPersonId", parseInt(getIdToken(), 10));

  return axios({
    method: "put",
    url: apiUrl + "/items/updatesubitem",
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function updateSubitemType(ID, ItemID, TypeID) {
  var params = new URLSearchParams();
  params.append("ID", ID);
  params.append("ItemID", ItemID);
  params.append("TypeID", TypeID);
  params.append("ModifiedByPersonId", parseInt(getIdToken(), 10));

  return axios({
    method: "put",
    url: apiUrl + "/items/updatesubitem",
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getPictoForSubItem(subItemId) {
  return axios({
    method: "get",
    url: apiUrl + "/items/getpicto/" + subItemId,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function addItemMetadata(itemNr, homepage, breakingnews, URL) {
  var params = new URLSearchParams();
  params.append("Itemnr", itemNr);
  params.append("Url", URL);
  params.append("Homepage", homepage);
  params.append("Breakingnews", breakingnews);

  return axios({
    method: "post",
    url: apiUrl + "/items/additemmetadata",
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getItemMetadata(itemNr) {
  var params = new URLSearchParams();
  params.append("itemnr", itemNr);

  return axios({
    method: "post",
    url: apiUrl + "/items/ItemMetadataForItemnr/" + itemNr,
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function addItemToUitzending(itemId, uitzendingId) {
  return axios({
    method: "post",
    url: `${apiUrl}/items/addItemToUitzending/${itemId}/${uitzendingId}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

// BCM ITEMTYPE
export function getItemTypes(programId) {
  return axios({
    method: "get",
    url: apiUrl + "/itemtype/itemtypes/" + programId,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function addItemTypetoItem(ID, ItemID, ItemTypeID) {
  var params = new URLSearchParams();
  params.append("ID", ID);
  params.append("ItemID", ItemID);
  params.append("ItemTypeID", ItemTypeID);

  return axios({
    method: "put",
    url: apiUrl + "/items/updateitemuitzending",
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function addType(omschrijving, active, hasCamera, showVideoStatus) {
  return axios({
    method: "post",
    url: `${apiUrl}/Type`,
    headers: {
      Authorization: getAccessToken()
    },
    data: {
      omschrijving,
      active,
      hasCamera,
      showVideoStatus
    }      
  })
    .then(res => res.data)
    .catch(error => error);
}

export function addTypeToProgram(programId, typeId) {
  return axios({
    method: "post",
    url: `${apiUrl}/Type/addtypetoprogramid/${typeId}/${programId}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function changeProgramOrder(data) {
  return axios({
    method: "post",
    url: `${apiUrl}/Program/ChangeProgramOrder`,
    data: data,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function removeTypeFromProgram(programId, typeId) {
  return axios({
    method: "delete",
    url: `${apiUrl}/Type/removetypefromprogramid/${programId}?typeID=${typeId}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getSubItemTypes(programId) {
  var params = new URLSearchParams();
  params.append("programID", programId);

  return axios({
    method: "get",
    url: apiUrl + "/Type/typesforprogramid/" + programId,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function updateUitzending(
  id,
  ProgramID,
  webtitel,
  webtekst,
  Geen_preroll,
  Bevat_aangekochte_beelden,
  FotoCategorie,
  Webtekst_html
) {
  var params = new URLSearchParams();
  params.append("ID", id);
  params.append("ProgramID", ProgramID);
  params.append("Webtitel", webtitel);
  params.append("Webtekst", webtekst);
  params.append("Geen_preroll", Geen_preroll);
  params.append("Bevat_aangekochte_beelden", Bevat_aangekochte_beelden);
  params.append("FotoCategorie", FotoCategorie);
  params.append("Webtekst_html", Webtekst_html);

  return axios({
    method: "put",
    url: apiUrl + "/Uitzending/updateuitzending",
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function addEindredacteur(ID, ProgramID, PersonID_Eindredacteur) {
  var params = new URLSearchParams();
  params.append("ID", ID);
  params.append("ProgramID", ProgramID);
  params.append("PersonID_Eindredacteur", PersonID_Eindredacteur);

  return axios({
    method: "put",
    url: apiUrl + "/Uitzending/updateuitzending",
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function addAnker(ID, ProgramID, PersonID_Anker) {
  var params = new URLSearchParams();
  params.append("ID", ID);
  params.append("ProgramID", ProgramID);
  params.append("PersonID_Anker", PersonID_Anker);

  return axios({
    method: "put",
    url: apiUrl + "/Uitzending/updateuitzending",
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function addReportertoItem(ID, ItemID, ReporterID) {
  var params = new URLSearchParams();
  params.append("ID", ID);
  params.append("ItemID", ItemID);
  params.append("ReporterID", ReporterID);

  return axios({
    method: "put",
    url: apiUrl + "/items/updateitemuitzending",
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

// BCM KEYVALUES
export function getKeyValuesforSubitem(subitemid) {
  var params = new URLSearchParams();
  params.append("subitemid", subitemid);

  return axios({
    method: "post",
    url: apiUrl + "/keyvalues/keyvaluessubitem/" + subitemid,
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

// KEYWORD

export function getAllKeywords() {
  return axios({
    method: "get",
    url: apiUrl + "/Keyword",
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}
export function keywordsForProgramId(programId) {
  return axios({
    method: "get",
    url: apiUrl + "/Keyword/keywordsforprogramid/" + programId,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function keywordsForItemNr(itemNr) {
  return axios({
    method: "get",
    url: apiUrl + "/Keyword/keywordsforitemnr/" + itemNr,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function keywordsForUitzendingId(uitzendingId) {
  return axios({
    method: "get",
    url: apiUrl + "/Keyword/keywordsforuitzendingid/" + uitzendingId,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function keywordsForItemId(itemId) {
  return axios({
    method: "get",
    url: apiUrl + "/Keyword/keywordsforitemid/" + itemId,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function addKeywordToUizendingId(keywordId, uitzendingID) {
  return axios({
    method: "post",
    url:
      apiUrl +
      "/Keyword/addkeywordtouitzending/" +
      keywordId +
      "/" +
      uitzendingID,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function addKeywordToProgram(keywordId, programId) {
  return axios({
    method: "get",
    url:
      apiUrl + "/Keyword/addkeywordtoprogramid/" + keywordId + "/" + programId,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function removeKeywordFromProgram(keywordId, programId) {
  return axios({
    method: "delete",
    url:
      apiUrl +
      "/Keyword/removekeywordfromprogramid/" +
      keywordId +
      "/" +
      programId,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function addKeywordToItemId(keywordId, itemID) {
  return axios({
    method: "post",
    url: apiUrl + "/Keyword/addkeywordtoitemid/" + keywordId + "/" + itemID,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function addKeywordToItemNr(keywordId, itemNr) {
  return axios({
    method: "post",
    url: apiUrl + "/Keyword/addkeywordtoitemnr/" + keywordId + "/" + itemNr,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function removeKeywordfromUitzendingId(keywordId, uitzendingID) {
  return axios({
    method: "delete",
    url:
      apiUrl +
      "/Keyword/removekeywordfromuitzending/" +
      keywordId +
      "/" +
      uitzendingID,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function removeKeywordfromItemId(keywordId, itemID) {
  return axios({
    method: "delete",
    url:
      apiUrl + "/Keyword/removekeywordfromitemid/" + keywordId + "/" + itemID,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function removeKeywordFromItemNr(keywordId, itemNr) {
  return axios({
    method: "delete",
    url:
      apiUrl + "/Keyword/removekeywordfromitemnr/" + keywordId + "/" + itemNr,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

// TAGS
export function getAllTags(channelId) {
  return axios({
    method: "get",
    url: apiUrl + "/Tags/GetAllTags/" + channelId,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getAllTagsPaged(channelId, data) {
  return axios({
    method: "post",
    url: apiUrl + "/Tags/GetTagsPaged/" + channelId,
    data: data,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function editTag(tagId, tagName) {
  const data = {
    TagId: tagId,
    TagName: tagName
  };

  return axios({
    method: "put",
    url: apiUrl + "/Tags/EditTag",
    data: data,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getTagsForAssetGroup(assetGroupId) {
  return axios({
    method: "get",
    url: apiUrl + "/AssetTags/GetTagsForAssetGroup/" + assetGroupId,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getTagsForUitzendingNr(uitzendNr) {
  return axios({
    method: "get",
    url: apiUrl + "/Tags/GetTagsForUitzending?uitzendNr=" + uitzendNr,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getTagsForItemNr(itemNr) {
  return axios({
    method: "get",
    url: apiUrl + "/Tags/GetTagsForItemNr?itemNr=" + itemNr,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function addTagToUitzending(uitzendNr, tag) {
  return axios({
    method: "post",
    url:
      apiUrl +
      "/Tags/AddTagToUitzending?uitzendNr=" +
      uitzendNr +
      "&tag=" +
      tag,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function addTagToItem(itemNr, tag) {
  return axios({
    method: "post",
    url: apiUrl + "/Tags/AddTagToItem?itemNr=" + itemNr + "&tag=" + tag,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function addTagToAsset(assetId, tag) {
  return axios({
    method: "post",
    url: apiUrl + "/AssetTags/AddTagToAsset?assetId=" + assetId + "&tag=" + tag,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function deleteTagFromUitzending(uitzendNr, tagId) {
  return axios({
    method: "delete",
    url:
      apiUrl +
      "/Tags/DeleteTagFromUitzending?uitzendNr=" +
      uitzendNr +
      "&tagId=" +
      tagId,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function deleteTagFromItem(itemNr, tagId) {
  return axios({
    method: "delete",
    url:
      apiUrl + "/Tags/DeleteTagFromItem?itemNr=" + itemNr + "&tagId=" + tagId,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function deleteTagFromAsset(assetId, tagId) {
  return axios({
    method: "delete",
    url:
      apiUrl +
      "/AssetTags/DeleteTagFromAsset?assetId=" +
      assetId +
      "&tagId=" +
      tagId,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function addTag(channelId, tag) {
  return axios({
    method: "post",
    url: apiUrl + "/Tags/AddTag?channelId=" + channelId + "&tag=" + tag,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function addTags(channelId, tags) {
  return axios({
    method: "post",
    url: apiUrl + "/Tags/AddTags?channelId=" + channelId,
    data: tags,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

//GEOTAG
export function getGeotagsForProgram(programId) {
  return axios({
    method: "get",
    url: apiUrl + "/Geotag/GetGeotagsForProgram/" + programId,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getGeotagsForUitzendingId(UitzendingId) {
  return axios({
    method: "get",
    url: apiUrl + "/Geotag/geotagsforuitzendingid/" + UitzendingId,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getGeotagsForItemId(ItemID) {
  return axios({
    method: "get",
    url: apiUrl + "/Geotag/geotagsforitemid/" + ItemID,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getGeotagGroupsForProgram(programId) {
  return axios({
    method: "get",
    url: apiUrl + "/Geotag/GetGeotagGroupsForProgram/" + programId,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getAllGeotagGroups() {
  return axios({
    method: "get",
    url: apiUrl + "/Geotag/GetGeotagGroups",
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function addGeotagGroupToProgram(programId, groupId) {
  return axios({
    method: "post",
    url: `${apiUrl}/Geotag/AddGeotagGroupToProgram/${programId}/${groupId}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function removeGeotagGroupFromProgram(programId, groupId) {
  return axios({
    method: "delete",
    url: `${apiUrl}/Geotag/DeleteGeotagGroupFromProgram/${programId}/${groupId}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function addGeotagToUitzendingId(UitzendingId, geoTagId) {
  return axios({
    method: "post",
    url:
      apiUrl +
      "/Geotag/addgeotagtouitzendingid/" +
      geoTagId +
      "/" +
      UitzendingId,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function addGeotagToItemId(ItemID, geoTagId) {
  return axios({
    method: "post",
    url: apiUrl + "/Geotag/addgeotagtoitemid/" + geoTagId + "/" + ItemID,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function removeGeotagFromUitzendingId(UitzendingId, geoTagId) {
  return axios({
    method: "delete",
    url:
      apiUrl +
      "/Geotag/removegettagfromuitzendingid/" +
      geoTagId +
      "/" +
      UitzendingId,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function removeGeotagFromItemId(ItemID, geoTagId) {
  return axios({
    method: "delete",
    url: apiUrl + "/Geotag/removegettagfromitemid/" + geoTagId + "/" + ItemID,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

// BCM ITEMBIJLAGEN
export function getItemBijlagen(itemnr) {
  var params = new URLSearchParams();
  params.append("itemnr", itemnr);

  return axios({
    method: "post",
    url: apiUrl + "/ItemBijlagen/attachmentsforitemnr/" + itemnr,
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function addItemBijlagen(itemnr, GPS_coordinates) {
  var params = new URLSearchParams();
  params.append("itemnr", itemnr);
  params.append("GPS_coordinates", GPS_coordinates);
  params.append("Added_by_personID", "253");

  return axios({
    method: "post",
    url: apiUrl + "/ItemBijlagen/",
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

// BCM UITZENDING
export function getUitzendingen(programId, date) {
  var params = new URLSearchParams();
  params.append("programID", programId);
  params.append("startdate", date);
  params.append("enddate", date);

  return axios({
    method: "post",
    url: apiUrl + "/Uitzending/uitzendingenbetweendates",
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function newUitzending(programId, date, uur) {
  var params = new URLSearchParams();
  params.append("programID", programId);
  params.append("datum", date);
  params.append("startuur", uur);

  return axios({
    method: "post",
    url: apiUrl + "/Uitzending/newuitzending",
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function newUitzendingWithName(programId, date, uur, name) {
  var params = new URLSearchParams();
  params.append("programID", programId);
  params.append("datum", date);
  params.append("startuur", uur);
  params.append("MultiurenName", name);

  return axios({
    method: "post",
    url: apiUrl + "/Uitzending/newuitzending",
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function createFormatUitzendingUren(programId, date) {
  var params = new URLSearchParams();
  params.append("programID", programId);
  params.append("datum", date);

  return axios({
    method: "post",
    url: apiUrl + "/Uitzending/createformatuitzendinguren",
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getUitzending(uitzendingId) {
  return axios({
    method: "get",
    url: apiUrl + "/Uitzending/GetUitzendingByUitzendingId/" + uitzendingId,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function setOnAir(uitzendingId) {
  var params = new URLSearchParams();
  params.append("uitzendingid", uitzendingId);

  return axios({
    method: "get",
    url: apiUrl + "/Uitzending/setonair/" + uitzendingId,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function setOnAirPlaylist(uitzendingId) {
  return axios({
    method: "get",
    url: apiUrl + "/Uitzending/setonairplaylist/" + uitzendingId,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function isOnAirPlaylist(uitzendingId) {
  return axios({
    method: "get",
    url: apiUrl + "/Uitzending/isonairplaylist/" + uitzendingId,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function triggerUitzendingType(uitzendingId) {
  return axios({
    method: "get",
    url:
      apiUrl + "/Uitzending/UitzendingTypeTrigger?uitzendingID=" + uitzendingId,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function setUitzendingPlaylist(uitzendingId, programId) {
  var params = new URLSearchParams();
  params.append("ID", uitzendingId);
  params.append("programID", programId);
  params.append("MultiurenName", "Playlist");
  params.append("UitzendingTypeID", 1);

  return axios({
    method: "put",
    url: apiUrl + "/Uitzending/updateuitzending",
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

// BCM STREAMONE
export function streamoneadd(itemNr, programId, S1_itemID) {
  var params = new URLSearchParams();
  params.append("ItemNr", itemNr);
  params.append("S1_itemID", S1_itemID);

  return axios({
    method: "post",
    url: apiUrl + "/streamone/streamoneadd?programId=" + programId,
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function streamoneGetProfileGroups(channelId, data = {}) {
  return axios({
    method: "post",
    url: `${apiUrl}/streamone/StreamOneProfilegroupView?channelId=${channelId}`,
    data: data,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

// BCM EXPORTER
export function getExportersForProgram(ProgramID) {
  return axios({
    method: "get",
    url: apiUrl + "/exporters/exportersforprogramid/" + ProgramID,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function setCheckForExporter(ExporterID, UitzendingID, bcmNr) {
  var params = new URLSearchParams();
  params.append("ExporterID", ExporterID);
  params.append("UitzendingID", UitzendingID);
  params.append("bcmNr", bcmNr);

  return axios({
    method: "post",
    url: apiUrl + "/exporters/setcheckforexporter",
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function setCheckForExporterAndRun(ExporterID, UitzendingID, BCMNr) {
  var params = new URLSearchParams();
  params.append("ExporterID", ExporterID);
  params.append("UitzendingID", UitzendingID);
  params.append("BCMNr", BCMNr);

  return axios({
    method: "post",
    url: apiUrl + "/exporters/setcheckforexporterandrun",
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function runExporter(ExporterID, UitzendingID, BCMNr) {
  var params = new URLSearchParams();
  params.append("ExporterID", ExporterID);
  params.append("UitzendingID", UitzendingID);
  params.append("BCMNr", BCMNr);

  return axios({
    method: "post",
    url: apiUrl + "/exporters/runexporter",
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function setUncheckForExporter(ExporterID, UitzendingID, bcmNr) {
  var params = new URLSearchParams();
  params.append("ExporterID", ExporterID);
  params.append("UitzendingID", UitzendingID);
  params.append("bcmNr", bcmNr);

  return axios({
    method: "post",
    url: apiUrl + "/exporters/setuncheckforexporter",
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function exportStatus(ExporterID, UitzendingID, bcmNr) {
  var params = new URLSearchParams();
  params.append("ExporterID", ExporterID);
  params.append("UitzendingID", UitzendingID);
  params.append("bcmNr", bcmNr);

  return axios({
    method: "post",
    url: apiUrl + "/exporters/exporterstatus",
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function exporterStatusssen(bcmnr) {
  return axios({
    method: "post",
    url: apiUrl + "/exporters/exporterstatussen?bcmnr=" + bcmnr,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

// ZEBRA STUDIO
export function studioCarboniteList() {
  return axios({
    method: "get",
    url: apiUrl + "/items/studiocarbonitelist",
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function studioCarboniteCameraList(programId) {
  return axios({
    method: "get",
    url: apiUrl + "/items/studiocarbonitecameralist/" + programId,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getStudioMeta(subitemId) {
  var params = new URLSearchParams();
  params.append("subitemid", subitemId);

  return axios({
    method: "get",
    url: apiUrl + "/items/studiosubitem/" + subitemId,
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => {
      var errortext = "error";
      return errortext;
    });
}

export function setStudioMeta(subItemId, StudioCooluxID, CooluxPictoMetadata) {
  var params = new URLSearchParams();
  params.append("SubItemID", subItemId);
  params.append("StudioCooluxID", StudioCooluxID);
  params.append("CooluxPictoMetadata", CooluxPictoMetadata);

  return axios({
    method: "post",
    url: apiUrl + "/items/addstudiosubitem",
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function addStudioCarbonite(subitemId, carboniteId) {
  var params = new URLSearchParams();
  params.append("subitemid", subitemId);
  params.append("StudioCarboniteID", carboniteId);

  return axios({
    method: "post",
    url: apiUrl + "/items/addstudiosubitem",
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function addStudioCarboniteCamera(subitemId, carboniteName) {
  var params = new URLSearchParams();
  params.append("subitemid", subitemId);
  params.append("StudioCarboniteCamera", carboniteName);

  return axios({
    method: "post",
    url: apiUrl + "/items/addstudiosubitem",
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function updateStudioCarbonite(subitemId, carboniteId) {
  var params = new URLSearchParams();
  params.append("subitemid", subitemId);
  params.append("StudioCarboniteID", carboniteId);

  return axios({
    method: "put",
    url: apiUrl + "/items/updatestudiosubitem",
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function updateStudioCarboniteCamera(subitemId, carboniteName) {
  var params = new URLSearchParams();
  params.append("subitemid", subitemId);
  params.append("StudioCarboniteCamera", carboniteName);

  return axios({
    method: "put",
    url: apiUrl + "/items/updatestudiosubitem",
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function addStudioWall(subitemId, cooluxId) {
  var params = new URLSearchParams();
  params.append("subitemid", subitemId);
  params.append("StudioCooluxID", cooluxId);

  return axios({
    method: "post",
    url: apiUrl + "/items/addstudiosubitem",
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function updateStudioWall(subitemId, cooluxId) {
  var params = new URLSearchParams();
  params.append("subitemid", subitemId);
  params.append("StudioCooluxID", cooluxId);

  return axios({
    method: "put",
    url: apiUrl + "/items/updatestudiosubitem",
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getStudioScenes(subitemId) {
  var params = new URLSearchParams();
  params.append("subitemid", subitemId);

  return axios({
    method: "get",
    url: apiUrl + "/items/studioscenes?subitemid=" + subitemId,
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function addStudioScene(data) {
  return axios({
    method: "post",
    url: apiUrl + "/items/addstudioscene",
    data: data,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function updateStudioScene(data) {
  return axios({
    method: "put",
    url: apiUrl + "/items/updatestudioscene",
    data: data,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function deleteStudioScene(subitemid, sceneid) {
  return axios({
    method: "delete",
    url: apiUrl + "/items/deletestudioscene/" + subitemid + "/" + sceneid,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getStudioStatus(uitzendingid) {
  var params = new URLSearchParams();
  params.append("uitzendingid", uitzendingid);

  return axios({
    method: "get",
    url: apiUrl + "/items/studiostatus/" + uitzendingid,
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getClipStatus(uitzendingid) {
  var params = new URLSearchParams();
  params.append("uitzendingid", uitzendingid);

  return axios({
    method: "get",
    url: apiUrl + "/items/studiostatusitems/" + uitzendingid,
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

// AUTHORIZATION - Person
export function getTokensForProgram(personId, programId) {
  var params = new URLSearchParams();
  params.append("personId", personId);
  params.append("programId", programId);

  return axios({
    method: "get",
    url:
      apiUrl +
      "/authorization/GetApiTokensForPersonAndProgram/" +
      personId +
      "/" +
      programId,
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

// AUTHORIZATION - Group
export function getAllGroups() {
  return axios({
    method: "get",
    url: apiUrl + "/authorization/GetAllApiGroups",
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getGroupById(id) {
  return axios({
    method: "get",
    url: apiUrl + "/authorization/GetApiGroupForGroupId/" + id,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getApiGroupsForPerson(personId) {
  return axios({
    method: "get",
    url: `${apiUrl}/authorization/GetApiGroupsForPerson/${personId}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function addApiGroup(ApiGroupName, ApiGroupDescription, CompanyID) {
  var params = new URLSearchParams();
  params.append("ApiGroupName", ApiGroupName);
  params.append("ApiGroupDescription", ApiGroupDescription);
  params.append("CompanyID", CompanyID);

  return axios({
    method: "post",
    url: apiUrl + "/authorization/AddApiGroup",
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function updateApiGroup(ApiGroupId, ApiGroupName, ApiGroupDescription) {
  var params = new URLSearchParams();
  params.append("ApiGroupId", ApiGroupId);
  params.append("ApiGroupName", ApiGroupName);
  params.append("ApiGroupDescription", ApiGroupDescription);

  return axios({
    method: "put",
    url: apiUrl + "/authorization/UpdateApiGroup",
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function deleteApiGroup(ApiGroupId) {
  return axios({
    method: "delete",
    url: apiUrl + "/authorization/DeleteApiGroup/" + ApiGroupId,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function AddPersonToApiGroup(PersonId, ApiGroupId) {
  return axios({
    method: "post",
    url:
      apiUrl +
      "/authorization/AddPersonToApiGroup/" +
      PersonId +
      "/" +
      ApiGroupId,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function RemovePersonFromApiGroup(PersonId, ApiGroupId) {
  return axios({
    method: "delete",
    url:
      apiUrl +
      "/authorization/RemovePersonFromApiGroup/" +
      PersonId +
      "/" +
      ApiGroupId,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function GetPersonsInApiGroup(id) {
  return axios({
    method: "get",
    url: apiUrl + "/authorization/GetPersonsInApiGroup/" + id,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function GetAllApiRoles() {
  return axios({
    method: "get",
    url: apiUrl + "/authorization/GetAllApiRoles",
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getRolesForGroup(id) {
  return axios({
    method: "post",
    url: apiUrl + "/authorization/GetApiRolesForApiGroup/" + id,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getApiRolesForPerson(personId) {
  return axios({
    method: "post",
    url: apiUrl + "/authorization/GetApiRolesForPerson/" + personId,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function AddGroupWithChannelToApiRole(groupId, programId, roleId) {
  return axios({
    method: "post",
    url:
      apiUrl +
      "/authorization/AddGroupWithChannelToApiRole/" +
      groupId +
      "/" +
      programId +
      "/" +
      roleId,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function RemoveGroupWithChannelFromApiRole(groupId, programId, roleId) {
  return axios({
    method: "delete",
    url:
      apiUrl +
      "/authorization/RemoveGroupWithChannelFromApiRole/" +
      groupId +
      "/" +
      programId +
      "/" +
      roleId,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function AddGroupWithProgramToApiRole(groupId, programId, roleId) {
  return axios({
    method: "post",
    url:
      apiUrl +
      "/authorization/AddGroupWithProgramToApiRole/" +
      groupId +
      "/" +
      programId +
      "/" +
      roleId,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function RemoveGroupWithProgramToApiRole(groupId, programId, roleId) {
  return axios({
    method: "delete",
    url:
      apiUrl +
      "/authorization/RemoveGroupWithProgramFromApiRole/" +
      groupId +
      "/" +
      programId +
      "/" +
      roleId,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function AddGroupWithAssetGroupToApiRole(groupId, assetGroupId, roleId) {
  return axios({
    method: "post",
    url:
      apiUrl +
      "/authorization/AddGroupWithAssetGroupToApiRole/" +
      groupId +
      "/" +
      assetGroupId +
      "/" +
      roleId,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function RemoveGroupWithAssetGroupFromApiRole(
  groupId,
  assetGroupId,
  roleId
) {
  return axios({
    method: "delete",
    url:
      apiUrl +
      "/authorization/RemoveGroupWithAssetGroupFromApiRole/" +
      groupId +
      "/" +
      assetGroupId +
      "/" +
      roleId,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function ApiTokens() {
  return axios({
    method: "get",
    url: apiUrl + "/authorization/ApiTokens",
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function AddApiTokenToApiRole(tokenId, roleId) {
  return axios({
    method: "post",
    url:
      apiUrl + "/authorization/AddApiTokenToApiRole/" + tokenId + "/" + roleId,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function DeleteApiTokenFromApiRole(tokenId, roleId) {
  return axios({
    method: "delete",
    url:
      apiUrl +
      "/authorization/DeleteApiTokenFromApiRole/" +
      tokenId +
      "/" +
      roleId,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function GetApiTokensFromApiRole(roleId) {
  return axios({
    method: "get",
    url: apiUrl + "/authorization/GetApiTokensFromApiRole/" + roleId,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function GetApiRolesFromPersonWithChannel(personId, channelId) {
  return axios({
    method: "get",
    url:
      apiUrl +
      "/authorization/GetApiRolesFromPersonWithChannel/" +
      personId +
      "/" +
      channelId,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function GetApiRolesFromPersonWithGroup(personId, groupId) {
  return axios({
    method: "get",
    url:
      apiUrl +
      "/authorization/GetApiRolesFromPersonWithAssetgroup/" +
      personId +
      "/" +
      groupId,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

// PERSON
export function getAllPersons() {
  return axios({
    method: "get",
    url: apiUrl + "/Person",
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getPersonById(id) {
  return axios({
    method: "get",
    url: apiUrl + "/Person/" + id,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getPersonsPaged(Filter, PageNumber, ItemsOnPage = 25) {
  const data = {
    Filter: Filter,
    PageNumber: PageNumber,
    ItemsOnPage: ItemsOnPage
  };

  return axios({
    method: "post",
    url: apiUrl + "/Person/GetPersonsPaged",
    data: data,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function createPerson(FirstName, Name, Email, Login, CompanyID) {
  const data = {
    FirstName: FirstName,
    Name: Name,
    Email: Email,
    Login: Login,
    LoginType: 1,
    CompanyID: CompanyID
  };

  return axios({
    method: "post",
    url: apiUrl + "/Person",
    data: data,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function updatePerson(ID, FirstName, Name, Email, Login) {
  var params = new URLSearchParams();
  params.append("ID", ID);
  params.append("FirstName", FirstName);
  params.append("Name", Name);
  params.append("Email", Email);
  params.append("Login", Login);

  return axios({
    method: "put",
    url: apiUrl + "/Person",
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function searchElastic(searchquery, Index) {
  var params = new URLSearchParams();
  params.append("Json", JSON.stringify(searchquery));
  params.append("Index", Index);

  return axios({
    method: "post",
    url: apiUrl + "/Elastic/search",
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

// StreamOne
export function getStreamOneId(itemNr) {
  return axios({
    method: "get",
    url: apiUrl + "/streamone/streamoneforitemnr/" + itemNr,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getStreaming(id) {
  return axios({
    method: "get",
    url: `https://playlist.a.zndznd.com/${id}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getVideoCodes(channelId) {
  var url =
    "https://zebraastor001webhook.blob.core.windows.net/public/ringtv_video.json";

  if (channelId === 64) {
    url =
      "https://zebraastor001webhook.blob.core.windows.net/public/rtv_video.json";
  }

  return axios({
    method: "get",
    url
  })
    .then(res => res.data)
    .catch(error => error);
}

export function saveUitzendingThumbnail(itemNr, base64, zebraId) {
  const data = {
    itemNr,
    base64,
    zebraId
  };

  return axios({
    method: "post",
    url: "https://zebra-a-func-001-webhook.azurewebsites.net/api/export_thumbnail_episode?code=Jehg1toMQ0Ch6urxCJgR6_CdSvmQQHHuxtoRQRhtovBUAzFu3mJPXg==",
    data
  })
    .then(res => res.data)
    .catch(error => error);
}

export function streamOneItemView(channelId, argumentsJson) {
  return axios({
    method: "post",
    url: apiUrl + "/streamone/StreamOneItemView?channelId=" + channelId,
    data: argumentsJson,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data.body)
    .catch(error => error);
}

export function streamOneGetPlaylist(streamOneId) {
  return axios({
    method: "get",
    url:
      "https://content.tmgvideo.nl/playlist/item=" +
      streamOneId +
      "/playlist.json"
  })
    .then(res => res.data)
    .catch(error => error);
}

export function streamOneItemCreate(channelId, argumentsJson) {
  return axios({
    method: "post",
    url: apiUrl + "/streamone/StreamOneItemCreate?channelId=" + channelId,
    data: argumentsJson,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data.body)
    .catch(error => error);
}

export function streamOneItemEdit(channelId, argumentsJson) {
  return axios({
    method: "put",
    url: apiUrl + "/streamone/StreamOneItemEdit?channelId=" + channelId,
    data: argumentsJson,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function streamOneItemDelete(channelId, item) {
  return axios({
    method: "delete",
    url: `${apiUrl}/streamone/StreamOneItemDelete?channelId=${channelId}&item=${item}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function streamOneItemAddToCategory(channelId, argumentsJson) {
  return axios({
    method: "post",
    url:
      apiUrl + "/streamone/StreamOneItemAddToCategory?channelId=" + channelId,
    data: argumentsJson,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function streamOneItemAddMetadata(channelId, argumentsJson) {
  return axios({
    method: "post",
    url: apiUrl + "/streamone/StreamOneItemAddMetadata?channelId=" + channelId,
    data: argumentsJson,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function streamOneItemEditFile(channelId, argumentsJson) {
  return axios({
    method: "put",
    url: apiUrl + "/streamone/StreamOneItemEditFile?channelId=" + channelId,
    data: argumentsJson,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function streamOneItemDeleteFile(channelId, argumentsJson) {
  return axios({
    method: "delete",
    url: apiUrl + "/streamone/StreamOneItemDeleteFile?channelId=" + channelId,
    data: argumentsJson,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function streamOneGetUploadToken(channelId, argumentsJson) {
  return axios({
    method: "post",
    url: apiUrl + "/streamone/StreamOneGetUploadToken?channelId=" + channelId,
    data: argumentsJson,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data.body)
    .catch(error => error);
}

export function streamOneSecurityProfileView(channelId, argumentsJson) {
  return axios({
    method: "post",
    url:
      apiUrl + "/streamone/StreamOneSecurityProfileView?channelId=" + channelId,
    data: argumentsJson,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data.body)
    .catch(error => error);
}

export function streamOneGetChannelIdForStreamOneAccount(streamOneAccount) {
  return axios({
    method: "get",
    url:
      apiUrl +
      "/streamone/GetChannelIdForStreamOneAccount?streamOneAccount=" +
      streamOneAccount,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function clearStreamoneThumbnail(Itemnr, S1_itemID, programId) {
  var params = new URLSearchParams();
  params.append("Itemnr", Itemnr);
  params.append("S1_itemID", S1_itemID);
  params.append("ThumbnailSentDate", "");
  params.append("ThumbnailReceivedDate", "");

  return axios({
    method: "put",
    url: apiUrl + "/streamone/streamoneupdate?programId=" + programId,
    data: params,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

// UPLOADER
let chunkTotal = 0;
let chunkCount = 0;
let PartCount = 0;

let fileChunkCache = [];

function uploadFileChunkSequential(
  TotalParts,
  FileName,
  callBack,
  apiCall,
  bearer,
  bcmNr,
  assetReference,
  attachmentType
) {
  const filename =
    sanitize(FileName, "") + ".part_" + PartCount + "." + TotalParts;
  const Chunk = fileChunkCache.shift();
  if (Chunk) {
    var formData = new FormData();
    formData.append("file", Chunk, filename);

    var xHttp = new XMLHttpRequest();
    xHttp.open("POST", apiCall, true);
    xHttp.onreadystatechange = function () {
      if (this.readyState === 4) {
        if (this.status === 200) {
          chunkCount = chunkCount + 1;
          var percentage = Math.round((chunkCount / chunkTotal) * 100);
          if (percentage > 100) {
            percentage = 100;
          }
          if (chunkCount === chunkTotal) {
            callBack("completed", 100);
          }
          callBack("progress", percentage);
          //const FilePartName = filename;
          // send the file
          PartCount++;
          uploadFileChunkSequential(
            TotalParts,
            FileName,
            callBack,
            apiCall,
            bearer,
            bcmNr,
            assetReference,
            attachmentType
          );
        } else {
          callBack("error", this.statusText);
        }
      }
    };
    xHttp.setRequestHeader("Authorization", bearer);
    if (assetReference) {
      xHttp.setRequestHeader("AssetReference", assetReference);
      xHttp.setRequestHeader("AttachmentType", attachmentType);
    }
    if (bcmNr) {
      xHttp.setRequestHeader("BCMNr", bcmNr);
      xHttp.setRequestHeader("AttachmentType", attachmentType);
    }

    xHttp.contentType = false;
    xHttp.processData = false;
    xHttp.send(formData);
  }
}

export function uploadFile(
  file,
  callBack,
  bcmNr = "",
  assetReference = "",
  attachmentType = 0
) {
  const apiCall = apiUrl + "/Upload/file?type=" + attachmentType;
  const timestamp = +new Date();
  const bearer = getAccessToken();
  // set up other initial vars
  const MaxFileSizeMB = 8;
  const BufferChunkSize = MaxFileSizeMB * (1024 * 1024);

  let FileStreamPos = 0;
  // set the initial chunk length
  let EndPos = BufferChunkSize;
  const Size = file.size;
  fileChunkCache = [];
  // add to the FileChunk array until we get to the end of the file
  while (FileStreamPos < Size) {
    // "slice" the file from the starting position/offset, to  the required length

    fileChunkCache.push(file.slice(FileStreamPos, EndPos));
    //FileChunk.push(file.slice(FileStreamPos, EndPos));
    FileStreamPos = EndPos; // jump by the amount read
    EndPos = FileStreamPos + BufferChunkSize; // set next chunk length
  }
  // get total number of "files" we will be sending
  const TotalParts = fileChunkCache.length;
  chunkTotal = TotalParts;
  chunkCount = 0;
  PartCount = 0;
  // loop through, pulling the first item from the array each time and sending it
  PartCount++;
  // file name convention

  // send the file

  uploadFileChunkSequential(
    TotalParts,
    file.name.replace(/\.[^/.]+$/, "") +
      "_" +
      timestamp +
      "." +
      file.name.replace(/^.*\./, ""),
    callBack,
    apiCall,
    bearer,
    bcmNr,
    assetReference,
    attachmentType
  );
}

// UPLOADER
function uploadFileChunk(
  Chunk,
  FileName,
  callBack,
  apiCall,
  bearer,
  bcmNr,
  assetReference,
  attachmentType
) {
  var formData = new FormData();
  formData.append("file", Chunk, FileName);

  var xHttp = new XMLHttpRequest();
  xHttp.open("POST", apiCall, true);
  xHttp.onreadystatechange = function () {
    if (this.readyState === 4) {
      if (this.status === 200) {
        chunkCount = chunkCount + 1;
        var percentage = Math.round((chunkCount / chunkTotal) * 100);
        if (percentage > 100) {
          percentage = 100;
        }
        if (chunkCount === chunkTotal) {
          callBack("completed", 100);
        }
        callBack("progress", percentage);
      } else {
        callBack("error", this.statusText);
      }
    }
  };
  xHttp.setRequestHeader("Authorization", bearer);
  if (assetReference) {
    xHttp.setRequestHeader("AssetReference", assetReference);
    xHttp.setRequestHeader("AttachmentType", attachmentType);
  }
  if (bcmNr) {
    xHttp.setRequestHeader("BCMNr", bcmNr);
    xHttp.setRequestHeader("AttachmentType", attachmentType);
  }

  xHttp.contentType = false;
  xHttp.processData = false;
  xHttp.send(formData);
}

export function uploadItemAttachment(
  file,
  callBack,
  bcmNr = undefined,
  attachmentType = 0
) {
  const apiCall = apiUrl + "/Upload/ItemAttachment";
  const bearer = getAccessToken();
  let FileChunk = [];
  // var file = document.getElementById(file).files[0];
  // set up other initial vars
  const MaxFileSizeMB = 1;
  const BufferChunkSize = MaxFileSizeMB * (1024 * 1024);
  let FileStreamPos = 0;
  // set the initial chunk length
  let EndPos = BufferChunkSize;
  const Size = file.size;
  // add to the FileChunk array until we get to the end of the file
  while (FileStreamPos < Size) {
    // "slice" the file from the starting position/offset, to  the required length
    FileChunk.push(file.slice(FileStreamPos, EndPos));
    FileStreamPos = EndPos; // jump by the amount read
    EndPos = FileStreamPos + BufferChunkSize; // set next chunk length
  }
  // get total number of "files" we will be sending
  const TotalParts = FileChunk.length;
  chunkTotal = TotalParts;
  let PartCount = 0;
  chunkCount = 0;
  // loop through, pulling the first item from the array each time and sending it
  let chunk = FileChunk.shift();
  while (chunk) {
    PartCount++;
    // file name convention
    const FilePartName = file.name + ".part_" + PartCount + "." + TotalParts;
    // send the file
    uploadFileChunk(
      chunk,
      FilePartName,
      callBack,
      apiCall,
      bearer,
      bcmNr,
      "",
      attachmentType
    );
    chunk = FileChunk.shift();
  }
}

export function getItemAttachments(itemNr, attachmentType) {
  return axios({
    method: "get",
    url: `${apiUrl}/items/GetItemAttachments?bcmnr=${itemNr}&attachmentType=${attachmentType}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function downloadItemAttachment(guid) {
  return axios({
    method: "get",
    responseType: "blob",
    url: `${apiUrl}/Download/GetItemAttachment?guid=${guid}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function deleteItemAttachment(guid) {
  return axios({
    method: "delete",
    url: `${apiUrl}/items/DeleteItemAttachment?guid=${guid}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getActionLogs(data) {
  return axios({
    method: "post",
    url: `${apiUrl}/Logging/GetActionLogs`,
    data: data,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getActionLogUsers() {
  return axios({
    method: "get",
    url: `${apiUrl}/Logging/GetActionLogUsers`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

// VIDEO

export function downloadVideo(fileName) {
  return `${apiUrl}/video/Download?bcmnr=${fileName}&token=${getAccessToken()}`;
}

// TRANSCODING
export function getTranscodingStates(
  channelId = 0,
  programId = 0,
  page = 1,
  results = 25,
  bcm = "",
  statusId = 0
) {
  const data = {
    PageNumber: page,
    ItemsOnPage: results
  };

  return axios({
    method: "post",
    url: `${apiUrl}/transcoding/GetAllItemTranscodingStates?channelId=${channelId}&programId=${programId}&bcm=${bcm}&statusId=${statusId}`,
    data: data,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getTranscodingStatusItems() {
  return axios({
    method: "get",
    url: `${apiUrl}/transcoding/GetAllTranscodingStatusItems`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

// EXTERNAL TASKS
export function addTask(data) {
  data.UserId = parseInt(getIdToken(), 10);

  return axios({
    method: "post",
    url: `${apiUrl}/ExternalTask/AddTask`,
    data: data,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getExternalTasks(
  userid = 0,
  status = "",
  page = 1,
  results = 25,
  toolId = ""
) {
  const data = {
    PageNumber: page,
    ItemsOnPage: results
  };
  return axios({
    method: "post",
    url: `${apiUrl}/ExternalTask/GetTasksForUser?userId=${userid}&status=${status}&toolId=${toolId}`,
    data: data,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getExternalTaskUsers() {
  return axios({
    method: "get",
    url: `${apiUrl}/ExternalTask/GetAllUsers`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getExternalTaskStatuses() {
  return axios({
    method: "get",
    url: `${apiUrl}/ExternalTask/GetAllStatuses`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getExternalTaskTools() {
  return axios({
    method: "get",
    url: `${apiUrl}/ExternalTask/GetAllTools`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

//Asset
export function getAsset(assetid) {
  return axios({
    method: "get",
    url: `${apiUrl}/assets/asset/${assetid}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getSubAssets(assetid) {
  return axios({
    method: "get",
    url: `${apiUrl}/assets/subassets/${assetid}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function addMultipleParent(subAssetId, parentAssetId) {
  return axios({
    method: "post",
    url: `${apiUrl}/assets/addmultipleparent/${subAssetId}/${parentAssetId}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function deleteMultipleParent(subAssetId, parentAssetId) {
  return axios({
    method: "delete",
    url: `${apiUrl}/assets/deletemultipleparent/${subAssetId}/${parentAssetId}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getAssetFromAssetReference(assetReference) {
  return axios({
    method: "get",
    url: `${apiUrl}/assets/assetreference/${assetReference}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function addAsset(data) {
  return axios({
    method: "post",
    url: `${apiUrl}/assets/addasset`,
    data: data,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function updateAsset(data) {
  return axios({
    method: "put",
    url: `${apiUrl}/assets/updateasset`,
    data: data,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

//AssetVideo
export function getAssetVideoUrl(filename) {
  const token = getAccessToken();
  return `${apiUrl}/AssetVideo?filename=${filename}&token=${token}`;
}

export function addAssetVideoThumbnail(data) {
  return axios({
    method: "post",
    url: apiUrl + "/AssetVideo/addAssetVideoThumbnail",
    data: data,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

//AssetVideoPreview
export function getVideoAssetPreviewComments(previewId, assetReference) {
  return axios({
    method: "get",
    url: `${apiUrl}/AssetVideoPreview/GetAllAssetVideoPreviewCommentsForPreviewAndAssetReference/${previewId}?assetReference=${assetReference}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getStatusLogHistoryAssetPreview(previewId) {
  return axios({
    method: "get",
    url: `${apiUrl}/AssetVideoPreview/GetStatusLogHistoryAssetPreview/${previewId}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getExternalAssetVideoDownloadLink(
  AssetReference,
  fileName,
  days = 10
) {
  const now = new Date();
  const expiry = new Date(new Date(Number(now)).setDate(now.getDate() + days));
  const data = {
    AssetReference: AssetReference,
    Filename: fileName,
    StarDate: getStringDate(now),
    ExpiryDate: getStringDate(expiry)
  };
  return axios({
    method: "post",
    url: `${apiUrl}/AssetVideo/getAssetVideoToken`,
    data: data,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => {
      return `${apiUrl}/AssetVideo/Download?filename=${fileName}&token=${res.data}&external=1`;
    })
    .catch(error => error);
}

export function getStringDate(date) {
  let month = String(date.getMonth() + 1).padStart(2, "0");
  let day = String(date.getDate()).padStart(2, "0");
  let year = date.getFullYear();
  let hours = String(date.getHours()).padStart(2, "0");
  let minutes = String(date.getMinutes()).padStart(2, "0");
  let seconds = String(date.getSeconds()).padStart(2, "0");
  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.000Z`;
}

export function downloadAssetVideo(fileLocation) {
  return `${config.VIDEO_URL}${fileLocation}`;
}

export function getAssetVideoPreviewForAssetReference(assetReference) {
  return axios({
    method: "get",
    url: `${apiUrl}/AssetVideoPreview/GetAssetVideoPreviewsForAssetReference?assetReference=${assetReference}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getAssetVideoPreviewForPreviewId(previewId) {
  return axios({
    method: "get",
    url: `${apiUrl}/AssetVideoPreview/GetAssetVideoPreviewByPreviewId/${previewId}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getPreviousPreviewComments(previewId) {
  return axios({
    method: "get",
    url: `${apiUrl}/AssetVideoPreview/getPreviousPreviewComments/${previewId}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getAssetVideoPreviewStatusses() {
  return axios({
    method: "get",
    url: `${apiUrl}/AssetVideoPreview/GetAllAssetVideoPreviewStatusses`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function updateAssetVideoPreviewStatus(
  previewId,
  statusId,
  userName,
  sendNotification,
  notificationRecipients
) {
  const data = {
    PreviewId: previewId,
    StatusId: statusId,
    UserName: userName,
    SendNotification: sendNotification,
    NotificationRecipients: notificationRecipients
  };

  return axios({
    method: "put",
    url: `${apiUrl}/AssetVideoPreview/UpdatePreviewStatus`,
    data: data,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function addAssetVideoPreviewComment(
  previewId = 0,
  assetReference = "",
  timeFrame = 0,
  personId = 0,
  username = "Unknown User",
  comment = "",
  overlayBase64 = "",
  parentId = 0
) {
  const data = {
    PreviewId: previewId,
    AssetReference: assetReference,
    TimeFrame: timeFrame,
    PersonId: personId,
    UserName: username,
    Comment: comment,
    OverlayBase64: overlayBase64,
    ParentId: parentId
  };
  return axios({
    method: "post",
    url: `${apiUrl}/AssetVideoPreview/AddAssetVideoPreviewComment`,
    data: data,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function removeAssetVideoPreviewComment(previewId, commentId) {
  return axios({
    method: "delete",
    url: `${apiUrl}/AssetVideoPreview/RemoveAssetVideoPreviewComment/${previewId}/${commentId}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function removeAssetVideoPreviewCommentExternal(
  previewId,
  commentId,
  token
) {
  return axios({
    method: "delete",
    url: `${apiUrl}/AssetVideoPreview/RemoveAssetVideoPreviewCommentExternal/${previewId}/${commentId}?token=${token}`
  })
    .then(res => res.data)
    .catch(error => error);
}

export function deleteAssetVideoPreview(previewId) {
  return axios({
    method: "delete",
    url: `${apiUrl}/AssetVideoPreview/DeleteAssetVideoPreview/${previewId}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function addAssetVideoPreview(
  assetReference,
  previewName,
  sharedEmail,
  expiryDate,
  allowComments,
  allowStatusChange,
  allowDownload,
  personId = parseInt(getIdToken(), 10)
) {
  const data = {
    AssetReference: assetReference,
    Name: previewName,
    SharedEmail: sharedEmail,
    ExpiryDate: expiryDate,
    AllowComments: allowComments,
    AllowPreviewStatusChange: allowStatusChange,
    AllowDownload: allowDownload,
    CreatedByPersonId: personId
  };
  return axios({
    method: "post",
    url: `${apiUrl}/AssetVideoPreview/AddAssetVideoPreview`,
    data: data,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function connectWebsocket(personId, filter, handler) {
  var connection = new WebSocket(
    `${apiUrl
      .replace("https", "wss")
      .replace(
        "http",
        "ws"
      )}/Notification/WebSocket/${personId}?filter=${filter}`
  );
  connection.onmessage = function (message) {
    handler(message.data);
  };
  return connection;
}

export function getAssetVideoPreviewExternalLink(previewId, userName) {
  return axios({
    method: "get",
    url: `${apiUrl}/AssetVideoPreview/GenerateExternalVideoPreviewLink/${previewId}?userName=${userName}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res)
    .catch(error => error);
}

export function decryptAssetVideoPreviewToken(token) {
  return axios({
    method: "get",
    url: `${apiUrl}/AssetVideoPreview/DecryptExternalVideoPreviewToken?token=${token}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res)
    .catch(error => error);
}

// Search MAM
export function searchElasticMam(searchquery) {
  var params = new URLSearchParams();
  params.append("searchquery", JSON.stringify(searchquery));
  params.append("index", config.MAM_INDEX);
  const msearchPayload = `{ }\n${JSON.stringify(searchQuery)}\n`;
  return axios({
    method: "post",
    headers: {
      token: getJwtToken()
    },
    url: `${config.SEARCH_ENDPOINT}${config.MAM_INDEX}/_search`,
    data: msearchPayload
  })
    .then(res => res.data)
    .catch(error => error);
}

export function searchGetItem(id) {
  let searchQuery = {
    query: {
      terms: {
        _id: [id]
      }
    }
  };
  // Prepare the payload for msearch
  const msearchPayload = `${JSON.stringify(searchQuery)}\n`;
  var params = new URLSearchParams();
  params.append("searchquery", JSON.stringify(searchQuery));
  params.append("index", "bcm");

  return axios({
    method: "post",
    headers: {
      token: getJwtToken()
    },
    url: `${config.SEARCH_ENDPOINT}${config.SEARCH_BCM_INDEX}/_search`,
    data: msearchPayload
  })
    .then(res => res.data.hits.hits[0]._source)
    .catch(error => error);
}

// MAILER
export function sendMail(recipients, subject, body) {
  const data = {
    Recipients: recipients,
    Subject: subject,
    Body: body
  };

  return axios({
    method: "post",
    url: `${apiUrl}/Mail/SendEmail`,
    data: data,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

//ASSETGROUP
export function getAllAssetGroups() {
  return axios({
    method: "get",
    url: `${apiUrl}/assetGroups/groups`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getAllAssetGroupsForChannel(channelId) {
  return axios({
    method: "get",
    url: `${apiUrl}/assetGroups/GetAssetGroupsForChannel/${channelId}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getAssetSeriesNamesForAssetgroup(groupId) {
  return axios({
    method: "get",
    url: `${apiUrl}/AssetSeriesName/GetAssetSeriesNamesForAssetGroup/${groupId}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getAssetSeriesNames() {
  return axios({
    method: "get",
    url: `${apiUrl}/AssetSeriesName/GetAssetSeriesNames`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function addAssetSeriesNameToAssetGroup(groupId, seriesNameId) {
  return axios({
    method: "post",
    url: `${apiUrl}/AssetSeriesName/AddAssetSeriesNameIdToAssetGroup/${groupId}/${seriesNameId}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function removeAssetSeriesNameFromAssetGroup(groupId, seriesNameId) {
  return axios({
    method: "delete",
    url: `${apiUrl}/AssetSeriesName/RemoveAssetSeriesNameFromAssetGroup/${groupId}/${seriesNameId}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function addNewAssetSeriesNameToAssetGroup(groupId, seriesName) {
  const data = {
    GroupId: groupId,
    SeriesName: seriesName
  };

  return axios({
    method: "post",
    url: `${apiUrl}/AssetSeriesName/AddAssetSeriesNameToAssetGroup`,
    data: data,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

// ASSETSHARE
export function shareAssetWithAssetgroup(
  assetId,
  groupId,
  message = "",
  sourceGroupId = 0
) {
  return axios({
    method: "post",
    url: `${apiUrl}/AssetShare/ShareAsset/${assetId}/${groupId}/${sourceGroupId}?message=${message}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function shareAssetWithAssetgroups(
  assetId,
  groupIds,
  message = "",
  sourceGroupId = 0
) {
  const data = {
    AssetId: assetId,
    SourceGroupId: sourceGroupId,
    Message: message,
    ShareGroups: groupIds
  };
  return axios({
    method: "post",
    url: `${apiUrl}/AssetShare/ShareAsset`,
    data: data,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getAssetSharesForAssetGroup(groupId) {
  return axios({
    method: "get",
    url: `${apiUrl}/AssetShare/GetSharedAssetsForAssetGroup/${groupId}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getAssetSharesForAssetGroupPaged(
  groupId,
  page = 1,
  results = 25
) {
  const data = {
    PageNumber: page,
    ItemsOnPage: results
  };

  return axios({
    method: "post",
    url: `${apiUrl}/AssetShare/GetSharedAssetsForAssetGroupPaged/${groupId}`,
    data: data,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getAssetGroup(groupId) {
  return axios({
    method: "get",
    url: `${apiUrl}/assetGroups/group/${groupId}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getAssetGroupsForPerson(personId) {
  return axios({
    method: "get",
    url: `${apiUrl}/assetGroups/GetAssetGroupsForPerson/${personId}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getAssetShareNotificationSettingsForUserForAssetGroup(
  userId,
  groupId
) {
  return axios({
    method: "get",
    url: `${apiUrl}/AssetShare/GetNotificationSettingsForUserForAssetGroup/${userId}/${groupId}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function addOrUpdateAssetShareNotificationSettingsForUserForAssetGroup(
  userId,
  groupId,
  notification = true,
  email = false
) {
  var data = {
    PersonId: userId,
    assetGroupId: groupId,
    Notification: notification,
    Email: email
  };
  return axios({
    method: "post",
    url: `${apiUrl}/AssetShare/AddOrUpdateNotificationSettingsForUser`,
    data: data,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getNewSharedAssetsForPerson(personId) {
  return axios({
    method: "get",
    url: `${apiUrl}/AssetShare/GetNewSharedAssetsForPerson/${personId}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function updateShareAsset(
  id,
  seen,
  flagged,
  active,
  label = null,
  message = null
) {
  const data = {
    Id: id,
    Seen: seen,
    Flagged: flagged,
    Active: active,
    Label: label,
    Message: message
  };
  return axios({
    method: "post",
    url: `${apiUrl}/AssetShare/UpdateShareAsset`,
    data: data,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

// EXTERNAL LOGIN
export function registerPersonExternal(
  username,
  email,
  password,
  password2,
  firstname,
  lastname,
  companyID
) {
  const data = {
    UserName: username,
    Password: password,
    PasswordRepeat: password2,
    FirstName: firstname,
    Name: lastname,
    CompanyID: companyID,
    Email: email
  };
  return axios({
    method: "post",
    url: `${apiUrl}/PersonExternal/Register`,
    data: data,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function verifyExternalUser(token, password, password2) {
  return axios({
    method: "get",
    url: `${apiUrl}/PersonExternal/Verify?token=${token}&password=${password}&password2=${password2}`
  })
    .then(res => res.data)
    .catch(error => error);
}

export function sendPasswordResetMail(email) {
  return axios({
    method: "post",
    url: `${apiUrl}/PersonExternal/PassWordResetMail?email=${email}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function sendVerificationMail(email) {
  return axios({
    method: "post",
    url: `${apiUrl}/PersonExternal/VerificationMail?email=${email}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}
export function resetPaswoord(email, token, password, password2) {
  return axios({
    method: "get",
    url: `${apiUrl}/PersonExternal/Reset?email=${email}&token=${token}&password=${password}&password2=${password2}`
  })
    .then(res => res.data)
    .catch(error => error);
}

// VIDEO

export function getVideoUrl(filename) {
  const token = getAccessToken();
  return `${apiUrl}/Video?filename=${filename}&token=${token}`;
}
export function getVideoFilePath(filename) {
  return axios({
    method: "get",
    url: `${apiUrl}/video/GetFilePathFromFileName?video=${filename}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

// FAVOURITE
export function getFavouritesForPerson(personId = parseInt(getIdToken(), 10)) {
  return axios({
    method: "get",
    url: `${apiUrl}/favourite/favouritesforpersonid/${personId}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function addAssetGroupToFavorites(
  assetgroupId,
  personId = parseInt(getIdToken(), 10)
) {
  return axios({
    method: "post",
    url: `${apiUrl}/favourite/addfavouriteassetgroup/${assetgroupId}/${personId}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function deleteFavorite(favouriteId) {
  return axios({
    method: "delete",
    url: `${apiUrl}/favourite/deletefavourite/${favouriteId}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function deleteFavoriteProgram(
  programId,
  personId = parseInt(getIdToken(), 10)
) {
  return axios({
    method: "delete",
    url: `${apiUrl}/favourite/deleteFavouriteProgram/${programId}/${personId}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function addProgramToFavourites(
  programId,
  personId = parseInt(getIdToken(), 10)
) {
  return axios({
    method: "post",
    url: `${apiUrl}/favourite/addfavouriteprogram/${programId}/${personId}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

// FEED
export function getBelgaAlgemeen(startdate, enddate) {
  return axios({
    method: "get",
    url: `${apiUrl}/feed/belgaalgemeen/${startdate}/${enddate}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getBelgaSport(startdate, enddate) {
  return axios({
    method: "get",
    url: `${apiUrl}/feed/belgasport/${startdate}/${enddate}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getFeedsOfChannel(channelId) {
  return axios({
    method: "get",
    url: `${apiUrl}/feed/feedsofchannel/${channelId}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getFeedContentFromId(id) {
  return axios({
    method: "get",
    url: `${apiUrl}/feed/feedcontentfromid/${id}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getChanneProgramUitzendingOverview(channelId, datum) {
  return axios({
    method: "get",
    url: `${apiUrl}/Uitzending/GetUitzendingenItemsOverzichtFromChannel?channelId=${channelId}&date=${datum}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getAllProgramTypes() {
  return axios({
    method: "get",
    url: `${apiUrl}/ProgramType`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}
export function getAllProgramSubTypes() {
  return axios({
    method: "get",
    url: `${apiUrl}/Type`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}
export function getSubTypesForProgram(programId) {
  return axios({
    method: "get",
    url: `${apiUrl}/Type/typesforprogramid/${programId}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getProgramsForPerson() {
  return axios({
    method: "get",
    url: `${apiUrl}/Program/GetAllProgramsForPerson`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function updateProgram(data) {
  return axios({
    method: "put",
    url: `${apiUrl}/Program`,
    data: data,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function updateChannel(data) {
  return axios({
    method: "put",
    url: `${apiUrl}/Channel`,
    data: data,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function addProgram(data) {
  return axios({
    method: "post",
    url: `${apiUrl}/Program`,
    data: data,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function disableProgram(id) {
  return axios({
    method: "delete",
    url: `${apiUrl}/Program/${id}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function enableProgram(id) {
  return axios({
    method: "get",
    url: `${apiUrl}/Program/enable/${id}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getAllPlayers() {
  return axios({
    method: "get",
    url: `${apiUrl}/Player`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getPlayer(id) {
  return axios({
    method: "get",
    url: `${apiUrl}/player/${id}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function deletePlayer(id) {
  return axios({
    method: "delete",
    url: `${apiUrl}/player/${id}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function addPlayer(name, embedCode) {
  const data = {
    name: name,
    embedCode: embedCode
  };
  return axios({
    method: "post",
    url: `${apiUrl}/Player`,
    data: data,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function updatePlayer(id, name, embedCode) {
  const data = {
    id: id,
    name: name,
    embedCode: embedCode
  };
  return axios({
    method: "put",
    url: `${apiUrl}/Player`,
    data: data,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getPlayersOfChannel(channelId) {
  return axios({
    method: "get",
    url: `${apiUrl}/player/channel/${channelId}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function deletePlayerFromChannel(channelId, playerId) {
  return axios({
    method: "delete",
    url: `${apiUrl}/player/channel/${channelId}/${playerId}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function addPlayerToChannel(channelId, playerId) {
  return axios({
    method: "post",
    url: `${apiUrl}/Player/channel/${channelId}/${playerId}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

// TRITON
export function getTritonCategories() {
  return axios({
    method: "get",
    url: `${apiUrl}/omnyStudio/category`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getProgramsForAsset(assetId) {
  return axios({
    method: "get",
    url: `${apiUrl}/assets/getProgramsForAsset/${assetId}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

// export function unpublishAssetTriton(tritonAssetId) { //unpublish is nieuwe fnc
//   return axios({
//     method: "get",
//     url: `${apiUrl}/assets/unpublishAssetTriton/${tritonAssetId}`,
//     headers: {
//       Authorization: getAccessToken(),
//     },
//   })
//     .then((res) => res.data)
//     .catch((error) => error);
// }

export function getAssetTritonData(assetId) {
  return axios({
    method: "get",
    url: `${apiUrl}/assets/assettritondataforassetid/${assetId}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function addAssetTritonData(data) {
  return axios({
    method: "post",
    url: `${apiUrl}/assets/assettritondataadd`,
    data: data,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => {
      throw error;
    });
}

export function updateAssetTritonData(data) {
  return axios({
    method: "post",
    url: `${apiUrl}/assets/assettritondataupdate`,
    data: data,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getAssetVideoPreviewIdByToken(token) {
  return axios({
    method: "get",
    url: `${apiUrl}/AssetVideoPreview/GetAssetVideoPreviewIdByToken?token=${token}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res)
    .catch(error => error);
}

export function uploadPicto(id, image, editedImage, meta) {
  const data = {
    id: id,
    ImageBase64Original: image,
    ImageBase64Edited: editedImage,
    ImageMetaData: meta
  };
  return axios({
    method: "post",
    url: `${apiUrl}/items/uploadThumbnailSubItem`,
    data: data,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getSubItem(id) {
  return axios({
    method: "get",
    url: `${apiUrl}/items/subitem/${id}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

//ASSET COPY TO
export function copyAssetToLocation(assetId, assetGroupId) {
  return axios({
    method: "post",
    url: `${apiUrl}/Assets/CopyAssetTo/${assetId}/${assetGroupId}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

//SUBTITLE
export function addSubtitleToAsset(
  assetId,
  subtitleFile,
  extension,
  languageId,
  subtitleFilename
) {
  var data = {
    AssetId: assetId,
    Content: subtitleFile,
    Extension: extension,
    AssetSubtitleLanguageId: languageId,
    Filename: subtitleFilename
  };
  return axios({
    method: "post",
    url: `${apiUrl}/assets/addSubtitleToAsset`,
    headers: {
      Authorization: getAccessToken()
    },
    data: data
  })
    .then(res => res.data)
    .catch(error => error);
}

export function removeAssetSubtitle(assetSubtitleId) {
  return axios({
    method: "delete",
    url: `${apiUrl}/assets/removeSubtitleFromAsset/${assetSubtitleId}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getAssetSubtitleLanguages() {
  return axios({
    method: "get",
    url: `${apiUrl}/assets/getAssetSubtitleLanguages`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getAssetSubtitles(assetId) {
  return axios({
    method: "get",
    url: `${apiUrl}/assets/getAssetSubtitles/${assetId}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function downloadSubtitle(subtitlePath) {
  return `${apiUrl}${subtitlePath}`;
}

export function deleteTritonDataById(id) {
  return axios({
    method: "delete",
    url: `${apiUrl}/assets/assettritondata/${id}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function addTritonImage(data) {
  return axios({
    method: "post",
    url: `${apiUrl}/assets/assettritondatauploadclipartwork`,
    headers: {
      Authorization: getAccessToken()
    },
    data: data
  })
    .then(res => res.data)
    .catch(error => error);
}

export function publishTritonClipById(id) {
  return axios({
    method: "post",
    url: `${apiUrl}/assets/assettritondatapublishclip/${id}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => {
      throw error;
    });
}

export function unPublishTritonClipById(id) {
  return axios({
    method: "post",
    url: `${apiUrl}/assets/assettritondataunpublishclip/${id}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getExport(id) {
  return axios({
    method: "get",
    url:
      "https://zebra-p-func-002-export-c4gaeyhyhbadfweb.northeurope-01.azurewebsites.net/api/export/" +
      id +
      "?code=MqyJ3U0EkiE-6oBgg8AT5uAjGSIjYGHRD33Kuc0yWvtRAzFu6uCSGQ=="
  })
    .then(res => res.data)
    .catch(error => error);
}

export function exportPublish(id) {
  return axios({
    method: "post",
    url:
      "https://zebra-p-func-002-export-c4gaeyhyhbadfweb.northeurope-01.azurewebsites.net/api/publish/" +
      id +
      "?code=MqyJ3U0EkiE-6oBgg8AT5uAjGSIjYGHRD33Kuc0yWvtRAzFu6uCSGQ=="
  })
    .then(res => res.data)
    .catch(error => error);
}

export function exportUnpublish(id) {
  return axios({
    method: "post",
    url:
      "https://zebra-p-func-002-export-c4gaeyhyhbadfweb.northeurope-01.azurewebsites.net/api/unpublish/" +
      id +
      "?code=MqyJ3U0EkiE-6oBgg8AT5uAjGSIjYGHRD33Kuc0yWvtRAzFu6uCSGQ=="
  })
    .then(res => res.data)
    .catch(error => error);
}

export function setBreaking(id, isBreaking) {
  const data = {
    isBreaking
  };

  return axios({
    method: "post",
    url:
      "https://zebra-p-func-002-export-c4gaeyhyhbadfweb.northeurope-01.azurewebsites.net/api/breaking/" +
      id +
      "?code=MqyJ3U0EkiE-6oBgg8AT5uAjGSIjYGHRD33Kuc0yWvtRAzFu6uCSGQ==",
    data
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getMeemooData(channelId, recordId) {
  return axios({
    method: "get",
    url: `${config.MEEMOO_RECORD_SEARCH_URL}&channel_id=${channelId}&record_id=${recordId}`,
    headers: {
      Authorization: getAccessToken()
    }
  })
    .then(res => res.data)
    .catch(error => error);
}

export function strapiExport(assetId, event, videoCode, streamingId) {
  var data = {
    id: assetId,
    event: event,
    videoCode: videoCode,
    streamingId: streamingId
  };

  return axios({
    method: "post",
    url: `${config.EXPORTER_DOMAIN}exporter/`,
    data: data
  })
    .then(res => res.data)
    .catch(error => error);
}

export function strapiExportUitzending(uitzendingId, event, program) {
  var data = {
    id: uitzendingId,
    event: event,
    program: program
  };

  return axios({
    method: "post",
    url: `${config.EXPORTER_DOMAIN}exporter/uitzending.php`,
    data: data
  })
    .then(res => res.data)
    .catch(error => error);
}

export function strapiGetVideoCode(assetId, zebraNr) {
  var data = {
    id: assetId,
    zebraNr
  };

  return axios({
    method: "post",
    url: `${config.EXPORTER_DOMAIN}exporter/getvideocode.php`,
    data: data
  })
    .then(res => res.data)
    .catch(error => error);
}

export function strapiGetVideoCodeUitzending(uitzendingId, zebraNr) {
  var data = {
    id: uitzendingId,
    zebraNr
  };

  return axios({
    method: "post",
    url: `${config.EXPORTER_DOMAIN}exporter/getvideocodeuitzending.php`,
    data: data
  })
    .then(res => res.data)
    .catch(error => error);
}

export function saveVideoTumbnail(itemNr, base64, zebraId) {
  const data = {
    itemNr,
    base64,
    zebraId
  };

  return axios({
    method: "post",
    url: "https://zebra-a-func-001-webhook.azurewebsites.net/api/export_thumbnail?code=ymlzV54nrTB_hXn8lqQFcG_cR-fpSLaZWi7Pq5qkn7duAzFuP_CXgA==",
    data
  })
    .then(res => res.data)
    .catch(error => error);
}


export function exportVideoThumbnail(itemNr, base64, zebraId) {
  const data = {
    itemNr,
    base64,
    zebraId
  };

  return axios({
    method: "post",
    url: "https://zebra-p-func-002-export-c4gaeyhyhbadfweb.northeurope-01.azurewebsites.net/api/export_thumbnail?code=MqyJ3U0EkiE-6oBgg8AT5uAjGSIjYGHRD33Kuc0yWvtRAzFu6uCSGQ==",
    data
  })
    .then(res => res.data)
    .catch(error => error);
}

export function getCompanies() {
  return axios({
    method: "get",
    url: `${apiUrl}/Company`,
    headers: {
      Authorization: getAccessToken()
    }
  })
      .then(res => res.data)
      .catch(error => error);
}